<template>
    <div>
        <div class="breadcrumb-layout" name="head-block">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>保养计划管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout" name="tree-block">
            <swb-popover-org-tree :showMgmt="true" :showIncludeSubComs="true" :initIncludeSubComs="false" @notity-change="notityChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :queryHandler="queryHandler" :onConfigReady="onConfigReady"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btn-block" v-if="checkActionPerm('create')">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="addDeviceMaintPlan">新增资产保养</button>
            </div>
            <div class="right">
                <span class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('delete')" @click="doBatchDelete()">批量删除</span>
                <span class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('termina')" @click="toTerminaBatch()">批量结束</span>
                <span class="swb-btn swb-btn-small swb-btn-primary" id="setTag" v-if="checkActionPerm('update_bizTag')" @click="toBizTag($event)">设置标签</span>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
        <swb-dt-popover ref="popoverRef" classes="popper-tabs">
            <swb-biz-tag-list-for-select :bizAspect="bizAspect" :selectIds="tagIds" ref="swb_biz_tag_list_for_select" @notity-bizTag-comfirm="doBizTagConfirm" @notity-bizTag-cancel="doBizTagCancel"></swb-biz-tag-list-for-select>
        </swb-dt-popover>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher, getComnMerchantBizTag } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../app.conf'
    import {
        showDeviceMainPlanForOneServicerDialog,
        showDeviceMainPlanForOneServicerBatchDialog,
        showDeviceMainPlanDialog,
        showDeviceMainPlanDetailDialog
    } from './dialog'
    import { openDeviceRepairRecDlg } from '../workVoucher/showDetailDlg'
    import { loadAssetKindList, loadRetailerDevcGroupList, loadRetailerShopTagList } from './asset-comn'
    //
    import shopDevcApi from '../../api/shopDevc'
    import devcApi from '../../api/devc'
    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user'
    import merchtComnApi from '../../api/merchtComn'
    //
    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);
    import SwbDeviceMalfunctionStatisList from './DeviceMalfunctionStatisList';
    Routes.add(SwbDeviceMalfunctionStatisList);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbBizTagListForSelect from '../bizTag/BizTagListForSelect';
    Vue.regist(SwbBizTagListForSelect);
    //
    let bizTagObj = null;
    //
    export default {
        name: 'swb-device-maint-plan-list',
        path: '/device/maint/plan/list',
        avlActions: 'view|delete',
        avlActionNames: '查看|删除',
        avlScopes: 'retailer',
        desc: '机构设备保养',
        helpArticleCode: 'retailer-device-maint-plan-list',
        data: function () {
            return {
                confKey: 'swb-device-maint-plan-list',
                queryOnLoad: true,
                tableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 250,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                bizUnitId: null,
                thisComId: null,
                thisComLevel: null,
                includeSubComs: false,
                comInfo: {},
                treeCollapse: true,
                //
                deviceMaintPlanList: [],
                oneServicerForoneMaintPlan: false,
                scopeEntity: null,
                mgmtSmlAreaId: null,
                bizAspect: getEnumInfoWith('retailerBizAspect', 'name', 'MaintPlan').value,
                tagIds: [],
                optionRows: [],
            }
        },
        watch: {
            '$route': 'fetchData'
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="head-block"],[name="tree-block"],[name="query-sort-block"],[name="btn-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        created: function () {
            bizTagObj = getComnMerchantBizTag();
            this.pageSize = this.pageSizes.first();
            //
            let tmpNo = this.$route.query.tmpNo || null;
            if(!Utils.isNoB(tmpNo)) {
                this.queryModel.filterItems.tmpNo = tmpNo;
            }
            let retailerComId = this.$route.query.retailerShopId || null;
            if(!Utils.isNoB(retailerComId)) {
                this.thisComId = retailerComId;
            }
            //
            this.getUserInfoByContext();
            //
            this.getComDetail();
            //
            // 获取【一个保养计划一个服务商】业务参数
            let self = this;
            let postData = {
                code: "one.servicer.for.one.maint.plan"
            };
            merchtComnApi.getMerchantBizParamValue(postData, function (result) {
                if(result.type === "info") {
                    self.oneServicerForoneMaintPlan = result.data;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'cronFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'terminated': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'limitEndTime': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.cronFlag && !Utils.isNoB(row.limitEndTime)) {
                            return '<span>' + row.limitEndTime + '</span>';
                        } else {
                            return '<span>无</span>';
                        }
                    },
                    'bizTag': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.bizTag)) {
                            let bizTag = row.bizTag;
                            let tagIdList = [];
                            if(!Utils.isNoB(bizTag)) {
                                if(bizTag.indexOf("|") >= 0) {
                                    bizTag = bizTag.substring(1, bizTag.length - 1);
                                    tagIdList = bizTag.split("|") || [];
                                } else {
                                    return '<span class="swb-tags swb-tags-success mr5">' + bizTag + '</span>';
                                }
                            }
                            let html = '';
                            for(let i = 0; i < tagIdList.length; i++) {
                                let tagId = parseInt(tagIdList[i]);
                                let tagName = bizTagObj.getBizTagNameById(tagId);
                                if(tagName != null) {
                                    html += '<span class="swb-tags swb-tags-success mr5">' + tagName + '</span>';
                                }
                            }
                            return html;
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if(self.checkActionPerm('view')) {
                            btnList.push({
                                name: 'view',
                                text: '查看'
                            })
                        }

                        if(self.checkActionPerm('update') && row.oneServicer && new Date(row.theDateTime).getTime() > new Date().getTime() && row.theDateTimeVer == 1 && !row.terminated) {
                            btnList.push({
                                name: 'update',
                                text: '编辑'
                            })
                        }
                        if(self.checkActionPerm('maint_plan_rec')) {
                            btnList.push({
                                name: 'maint_plan_rec',
                                text: '保养记录'
                            })
                        }
                        if(self.checkActionPerm('termina') && !row.terminated) {
                            btnList.push({
                                name: 'termina',
                                text: '结束'
                            })
                        }
                        if(self.checkActionPerm('delete') && row.terminated) {
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            })
                        }
                        if(self.checkActionPerm('update_bizTag')) {
                            btnList.push({
                                name: 'update_bizTag',
                                text: '设置标签'
                            })
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'view') {
                            self.toDeviceMaintPlanDetail(row.id);
                        } else if(btnName == 'maint_plan_rec') {
                            self.showDeviceRepairRec(row.id);
                        } else if(btnName == 'termina') {
                            self.toTermina(row.id);
                        } else if(btnName == 'delete') {
                            self.toDeleteDeviceMaintPlan(row.id);
                        } else if(btnName == 'update_bizTag') {
                            self.toBizTag(null, row);
                        } else if(btnName == 'update') {
                            self.toUpdate(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            fetchData: function () {
                this.pageSize = this.pageSizes.first();
                //
                let tmpNo = this.$route.query.tmpNo || null;
                if(!Utils.isNoB(tmpNo)) {
                    this.queryModel.filterItems.tmpNo = tmpNo;
                }
                let retailerComId = this.$route.query.retailerShopId || null;
                if(!Utils.isNoB(retailerComId)) {
                    this.thisComId = retailerComId;
                }
                //
                this.getUserInfoByContext();
                //
                this.getComDetail();
                this.toGetDeviceMaintPlanList();
            },
            getComDetail: function () {
                let self = this;
                let postData = {
                    comId: this.thisComId
                };
                retailerApi.getRetailerCom(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        self.comInfo = Utils.merge({}, result.data);
                        self.bizUnitId = self.comInfo.bizUnitId;
                        self.thisComLevel = self.comInfo.level;
                    } else {
                        MsgBox.error(result.message);
                    }
                });
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            getUserInfoByContext: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        let userContext = result.data;
                        self.scopeEntity = userContext.scopeEntity;
                        self.bizUnitId = userContext.scopeEntity.bizUnitId;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            //
            searchMethod: function (queryModel) {
                //
                this.tradeVoucherType = queryModel.filterItems.tradeVoucherType;
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.toGetDeviceMaintPlanList();
            },
            notityChange: function (eventData) {
                this.mgmtSmlAreaId = null;
                if(Utils.isTrue(eventData.mgmtFlag)) {
                    let scopeEntity = this.scopeEntity;
                    this.thisComLevel = scopeEntity.comLevel;
                    this.thisComId = scopeEntity.comId;
                    this.bizUnitId = scopeEntity.bizUnitId;
                    this.includeSubComs = true;
                    this.mgmtSmlAreaId = eventData.id;
                } else {
                    this.thisComId = eventData.id;
                    this.bizUnitId = eventData.bizUnitId;
                    this.thisComLevel = eventData.level;
                    this.includeSubComs = eventData.includeSubComs;
                }
                this.getComDetail();
                this.toGetDeviceMaintPlanList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.toGetDeviceMaintPlanList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.toGetDeviceMaintPlanList();
            },
            // 获取机构设备保养计划列表
            toGetDeviceMaintPlanList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                postData.filterItems = Utils.merge({}, this.queryModel.filterItems);
                postData.sortItemList = Utils.merge([], this.queryModel.sortItemList);
                postData.sortItems = Utils.merge({}, this.queryModel.sortItems);
                //
                postData.filterItems.bizUnitId = self.bizUnitId;    // 此处为业务单元级别，仅可选
                postData.filterItems.comLevel = self.thisComLevel;
                postData.filterItems.includeSubComs = self.includeSubComs;
                postData.filterItems.mgmtSmlAreaId = self.mgmtSmlAreaId;
                postData.filterItems.rented = false;
                //
                let theLoad = MsgBox.loading();
                shopDevcApi.getDeviceMaintPlanList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let deviceMaintPlanList = result.data.rows || [];
                        self.deviceMaintPlanList = Utils.merge([], deviceMaintPlanList);
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(deviceMaintPlanList, pagination);

                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getRetailerShopTagList (callback) {
                let self = this;
                //
                let loading = MsgBox.loading();
                retailerApi.getRetailerShopTagListByContext({}, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let retailerShopTagList = result.data;
                        let showTagList = [];
                        if(!Utils.isNoB(retailerShopTagList) && retailerShopTagList.length > 0) {
                            retailerShopTagList.forEach(function (item) {
                                showTagList.push({
                                    value: item.id,
                                    label: item.name
                                });
                            });
                        }
                        callback(showTagList);
                        //
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            //
            queryHandler(queryModel) {
                //缓存查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.toGetDeviceMaintPlanList();
            },
            // 新增设备保养计划
            addDeviceMaintPlan: function () {
                let self = this;
                let params = {
                    retailerId: self.comInfo.merchantId,
                    retailerComId: self.bizUnitId,
                    retailerShopName: self.comInfo.name,
                    comLevel: self.thisComLevel,
                    started: true,
                    lowCostFlag: false,
                    specialFlag: false
                };
                // 一个保养计划一个服务商
                if(this.oneServicerForoneMaintPlan) {
                    showDeviceMainPlanForOneServicerBatchDialog(params, function (theDlg) {
                        theDlg.close();
                        MsgBox.success("保存成功");
                        //
                        self.pageNumber = 1;
                        self.toGetDeviceMaintPlanList();
                    });
                } else {
                    showDeviceMainPlanDialog(params, function (theDlg) {
                        theDlg.close();
                        MsgBox.success("保存成功");
                        //
                        self.pageNumber = 1;
                        self.toGetDeviceMaintPlanList();
                    });
                }
            },
            toUpdate(row){
                let self = this;
                showDeviceMainPlanForOneServicerDialog({
                    id: row.id
                }, function (theDlg) {
                    theDlg.close();
                    MsgBox.success("保存成功");
                    //
                    self.pageNumber = 1;
                    self.toGetDeviceMaintPlanList();
                });
            },
            showDeviceRepairRec: function (id) {      // 查看维保记录
                //
                openDeviceRepairRecDlg(null, false, true, id);
            },
            // 删除设备保养计划
            toDeleteDeviceMaintPlan: function (id) {
                let self = this;
                self.$confirm('确定要删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let params = {
                        id: id
                    };
                    //
                    let msgBoxDlg = MsgBox.loading();
                    devcApi.deleteDeviceMaintPlan(params, function (result) {
                        msgBoxDlg.close();
                        if(result.type == 'info') {
                            MsgBox.success("删除成功");
                            self.toGetDeviceMaintPlanList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 设备保养计划详情
            toDeviceMaintPlanDetail: function (id) {
                showDeviceMainPlanDetailDialog(id);
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            // 跳转到请求单列表
            toReqVoucherDetail: function (reqVoucherNo) {
                this.$router.push({
                    path: SwbDeviceMalfunctionStatisList.path,
                    query: {
                        no: reqVoucherNo,
                        back: true,
                        gotoReqVoucher: true,
                        backUrl: "maintPlan"
                    }
                })
            },
            toTermina(id){
                let self = this;
                self.$confirm('确定要结束吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let params = {
                        id: id
                    };
                    //
                    let msgBoxDlg = MsgBox.loading();
                    devcApi.doDeviceMaintPlanTermina(params, function (result) {
                        msgBoxDlg.close();
                        if(result.type == 'info') {
                            MsgBox.success("操作成功");
                            self.toGetDeviceMaintPlanList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            toTerminaBatch(){
                let self = this;
                let checkList = this.getTableSelection();
                if(checkList == null || checkList.length <= 0) {
                    Toast.show("请选择要操作的数据！");
                    return;
                }
                let ids = [];
                for(let i = 0; i < checkList.length; i++) {
                    let row = checkList[i];
                    if(!row.terminated) {
                        ids.push(row.id);
                    }
                }
                if(ids.length == 0) {
                    Toast.show("没有可结束的计划！");
                    return;
                }
                //
                self.$confirm('确定要结束吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let msgBoxDlg = MsgBox.loading();
                    devcApi.doDeviceMaintPlanTerminaBatch(ids, function (result) {
                        msgBoxDlg.close();
                        if(result.type == 'info') {
                            MsgBox.success("操作成功");
                            self.toGetDeviceMaintPlanList();
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 批量删除
            doBatchDelete: function () {
                let self = this;

                let checkList = this.getTableSelection() || [];
                if(checkList.length <= 0) {
                    Toast.show("请选择要删除的数据！");
                    return;
                }
                let errMsg = '';
                for(let i = 0; i < checkList.length; i++) {
                    let maintPlan = checkList[i];
                    if(!Utils.isTrue(maintPlan.terminated)) {
                        errMsg = '已结束的计划才可删除！';
                        break;
                    }
                }
                if(!Utils.isNoB(errMsg)) {
                    MsgBox.warning(errMsg);
                    return;
                }

                self.$confirm('确定要删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let ids = checkList.pluck("id") || [];
                    let postData = {
                        ids: ids
                    };
                    //
                    let msgBoxDlg = MsgBox.loading();
                    devcApi.doBatchDeleteDeviceMaintPlan(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type == 'info') {
                            MsgBox.success("删除成功");
                            self.toGetDeviceMaintPlanList();
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            onConfigReady(){
                let self = this;
                // 门店标签
                loadRetailerShopTagList(function (dataList) {
                    self.updateQueryModelField("shopTagId", dataList);
                });
                // 业务标签
                bizTagObj.loadSelectBizTagByBizAspect(self.bizAspect, function (dataList) {
                    self.updateQueryModelField("bizTag", dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            toBizTag: function (event, row) {
                //
                let nextFlag = false;
                bizTagObj.getBizTagCount(this.bizAspect, function (count) {
                    if(Utils.isNoB(count) || count <= 0) {
                        Toast.show("没有可选择的标签，请先维护相应的业务标签！", 1000, 'warning');
                        return false;
                    } else {
                        nextFlag = true;
                    }
                });
                if(Utils.isTrue(nextFlag)) {
                    let popoverRef = this.$refs.popoverRef;
                    if(popoverRef != null) {
                        popoverRef.doClear();
                    }
                    //
                    let optionRows = [];
                    let curBtn = null;
                    let bizTag = null;
                    if(Utils.isNoB(event) && !Utils.isNoB(row) && row.id > 0) {
                        curBtn = document.getElementById('setTag');
                        bizTag = row.bizTag;
                        let tagIdList = [];
                        if(!Utils.isNoB(bizTag)) {
                            bizTag = bizTag.substring(1, bizTag.length - 1);
                            let idList = bizTag.split("|") || [];
                            for(let i = 0; i < idList.length; i++) {
                                let id = idList[i];
                                tagIdList.push(parseInt(id));
                            }
                        }
                        this.tagIds = Utils.merge([], tagIdList);
                        optionRows.push(row);
                        this.batchFlag = false;

                    } else {
                        let checkList = this.getTableSelection();
                        if(checkList == null || checkList.length <= 0) {
                            Toast.show("请选择要设置的数据！");
                            return;
                        }
                        curBtn = event.currentTarget;
                        optionRows = checkList;
                        this.batchFlag = true;
                        let tagIdList = [];
                        this.tagIds = Utils.merge([], tagIdList);
                    }
                    //
                    this.optionRows = Utils.merge([], optionRows);
                    //
                    popoverRef = this.$refs.popoverRef;

                    popoverRef.bindToReferer(
                        curBtn, 'click', {
                            showNow: true,
                            placement: 'left-start'
                        }
                    )
                }
            },
            doBizTagConfirm: function (bizTagList) {
                let self = this;
                let optionRows = this.optionRows || [];
                let idList = optionRows.pluck("id") || [];
                let tagIds = bizTagList.pluck("id") || [];
                this.tagIds = tagIds;
                //
                let postData = {
                    batchFlag: this.batchFlag,
                    idList: idList,
                    tagIds: tagIds
                };
                let theLoad = MsgBox.loading();
                devcApi.updateMaintPlanBizTag(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let popoverRef = self.$refs.popoverRef;
                        popoverRef.doHide();
                        MsgBox.success("设置成功！");
                        //
                        let resultTable = self.$refs['result_table'];
                        resultTable.setInitChecked([]);
                        self.toGetDeviceMaintPlanList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            doBizTagCancel: function () {
                let popoverRef = this.$refs.popoverRef;
                popoverRef.doHide();
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceMaintPlanList.vue